export class GdsgObjectEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "GdsgObjectEntryRoleEnum",
            "format": ""
        },
        {
            "name": "size",
            "baseName": "size",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "contentType",
            "baseName": "contentType",
            "type": "string",
            "format": ""
        },
        {
            "name": "tier",
            "baseName": "tier",
            "type": "GdsgObjectEntryTierEnum",
            "format": ""
        },
        {
            "name": "lastModified",
            "baseName": "lastModified",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "etag",
            "baseName": "etag",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GdsgObjectEntry.attributeTypeMap;
    }
    constructor() {
    }
}
export var GdsgObjectEntryRoleEnum;
(function (GdsgObjectEntryRoleEnum) {
    GdsgObjectEntryRoleEnum["Primary"] = "primary";
    GdsgObjectEntryRoleEnum["DrReplica"] = "drReplica";
})(GdsgObjectEntryRoleEnum || (GdsgObjectEntryRoleEnum = {}));
export var GdsgObjectEntryTierEnum;
(function (GdsgObjectEntryTierEnum) {
    GdsgObjectEntryTierEnum["Standard"] = "standard";
    GdsgObjectEntryTierEnum["Nearline"] = "nearline";
    GdsgObjectEntryTierEnum["Coldline"] = "coldline";
    GdsgObjectEntryTierEnum["Archive"] = "archive";
})(GdsgObjectEntryTierEnum || (GdsgObjectEntryTierEnum = {}));
